import React, {Component} from 'react';
import './ValidatingInput.css';

class ValidatingInput extends Component {
	render() {
		const {
			type = 'text',
			id,
			maxLength,
			className,
			placeholder,
			value,
			onKeyPress,
			onChange,
			onBlur,
			isValid,
			name,
			autoComplete,
			readOnly,
			states = {
				valid: {
					icon: 'icon-check',
					colour: 'green',
					title: '',
					message: ''
				},
				invalid: {
					icon: 'icon-error',
					colour: 'red',
					title: this.props.invalidTitle || '',
					message: this.props.invalidMessage || ''
				},
				unknown: {
					icon: this.props.validIcon || '',
					colour: undefined,
					title: '',
					message: ''
				}
			}
		} = this.props;

		let state = this.props.state;

		if (!state) {
			state = isValid === true ? 'valid' : isValid === false ? 'invalid' : 'unknown';
		}

		const stateProps = states[state];

		return (
			<div className="ValidatingInput">
				<input
					type={type}
					id={id}
					maxLength={maxLength}
					className={className}
					placeholder={placeholder}
					value={value}
					onKeyPress={onKeyPress}
					onChange={onChange}
					onBlur={onBlur}
					name={name}
					autoComplete={autoComplete}
					readOnly={readOnly}
				/>
				<span className="ValidatingInput-verification" title={stateProps && stateProps.title}>
					<span
						className={`icon ${stateProps && stateProps.icon}`}
						style={{
							color: stateProps && stateProps.colour
						}}
					/>
					<span className="ValidatingInput-message">{stateProps && stateProps.message}</span>
				</span>
				{stateProps && stateProps.caption && (
					<div className="ValidatingInput-caption" style={stateProps.captionStyle}>
						{stateProps.caption}
					</div>
				)}
			</div>
		);
	}
}

export default ValidatingInput;



// WEBPACK FOOTER //
// ./src/widgets/ValidatingInput.js